import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { getJpdViewsServicePathPrefix } from '@jira/polaris__lib-jpd-views-service/src/index.tsx';
import type { NavigationView } from './NavigationView.types.tsx';

export const createView = (params: {
	viewType: 'LIST' | 'BOARD' | 'MATRIX' | 'TIMELINE' | 'SECTION' | 'TREE';
	parentId: string;
	parentType: 'PROJECT' | 'SECTION' | 'COLLECTION';
	name?: string;
	emoji?: string;
}): Promise<NavigationView> =>
	performPostRequest(`${getJpdViewsServicePathPrefix()}/v1/views`, {
		body: JSON.stringify(params),
	});
